export default "__VITE_ASSET__mHIZLgGj__"